import { match, P } from "ts-pattern";
import { RoleType, ViewerQuery } from "../api/generated/graphql";

export const isCaregiver = (viewer?: ViewerQuery["viewer"]) =>
  !!viewer?.roles.find((role) => role.roleType === "CAREGIVER");

type ViewerRolesSimplified = {
  roleType: RoleType;
}[];

export const isOnlyContact = (roles: ViewerRolesSimplified) =>
  match(roles)
    .with([], () => false)
    .with(P.array(P._), (roles) =>
      roles.every(({ roleType }) => roleType === "CONTACT"),
    )
    .exhaustive();
